// Libraries
import { Card, Flex, Text } from '@chakra-ui/react';
// Components
import { RatingWidgetItem } from './Components';
import { RatingWidgetProps } from './RatingWidget.types';

/**
 * A component representing a rating widget that displays multiple rating items.
 *
 * @component
 * @param {RatingWidgetProps} props - The props for the RatingWidget component.
 * @param {RatingWidgetItemProps[]} props.ratingItems - An array of rating item props to be displayed in the rating widget.
 * @param {string} props.caption - A caption or title for the rating widget.
 * @returns {ReactElement} The JSX element representing the rating widget.
 */
export const RatingWidget = ({ ratingItems, caption }: RatingWidgetProps) => (
  <Card w='full' px={4} py={{ base: 4, md: 2 }}>
    <Flex
      columnGap={{ base: 3, md: 8 }}
      alignItems='center'
      flexWrap='wrap'
      rowGap={3}
      w={{ base: 'full', md: 'auto' }}
      justify={{ base: 'space-around' }}
    >
      {ratingItems.map(({ label, score, rating }) => (
        <RatingWidgetItem key={label} label={label} score={score} rating={rating} />
      ))}
    </Flex>
    <Text pt={{ base: 1, md: 3 }} variant='faded' fontSize='xs'>
      {caption}
    </Text>
  </Card>
);
